export default {
    headers: [
        {
            text: 'Location ID',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['location_site_id']
        },
        {
            text: 'Location Name',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['name']
        },
        {
            text: 'Client Name',
            showSort: false,
            columnSize: 'md',
            nestedDisplayKeys: ['client_name']
        },
        {
            text: 'Client ID',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['client_site_id']
        },
        {
            text: 'State/Province',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['state']
        },
        {
            text: 'City',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['city']
        },
        {
            text: 'Primary Address',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['address_1']
        },
        {
            text: 'Secondary Address',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['address_2']
        },
        {
            text: 'Zip Code',
            showSort: true,
            columnSize: 'md',
            nestedDisplayKeys: ['postal_code']
        }
    ]
}



// WEBPACK FOOTER //
// ./app/components/site-lookup/site-lookup-header.json.js